<input type="checkbox"
       id="{{id}}"
       [(ngModel)]="isChecked"
       binary="true" />
<label for="{{id}}">
    <i></i>
</label>
